/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatientLightResponse } from './PatientLightResponse';
import {
    PatientLightResponseFromJSON,
    PatientLightResponseFromJSONTyped,
    PatientLightResponseToJSON,
    PatientLightResponseToJSONTyped,
} from './PatientLightResponse';

/**
 * response tying a patient with its appointment
 * @export
 * @interface WaitingPatientAppointmentResponse
 */
export interface WaitingPatientAppointmentResponse {
    /**
     * Unique identifier of the appointment.
     * @type {string}
     * @memberof WaitingPatientAppointmentResponse
     */
    appointmentId: string;
    /**
     * 
     * @type {PatientLightResponse}
     * @memberof WaitingPatientAppointmentResponse
     */
    patient: PatientLightResponse;
    /**
     * 
     * @type {boolean}
     * @memberof WaitingPatientAppointmentResponse
     */
    noLinkedAtPatient?: boolean;
}

/**
 * Check if a given object implements the WaitingPatientAppointmentResponse interface.
 */
export function instanceOfWaitingPatientAppointmentResponse(value: object): value is WaitingPatientAppointmentResponse {
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('patient' in value) || value['patient'] === undefined) return false;
    return true;
}

export function WaitingPatientAppointmentResponseFromJSON(json: any): WaitingPatientAppointmentResponse {
    return WaitingPatientAppointmentResponseFromJSONTyped(json, false);
}

export function WaitingPatientAppointmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WaitingPatientAppointmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentId': json['appointmentId'],
        'patient': PatientLightResponseFromJSON(json['patient']),
        'noLinkedAtPatient': json['noLinkedAtPatient'] == null ? undefined : json['noLinkedAtPatient'],
    };
}

export function WaitingPatientAppointmentResponseToJSON(json: any): WaitingPatientAppointmentResponse {
    return WaitingPatientAppointmentResponseToJSONTyped(json, false);
}

export function WaitingPatientAppointmentResponseToJSONTyped(value?: WaitingPatientAppointmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentId': value['appointmentId'],
        'patient': PatientLightResponseToJSON(value['patient']),
        'noLinkedAtPatient': value['noLinkedAtPatient'],
    };
}

